<template>
  <div class="oneui">
    <div></div>
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.linkPatreon')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div class="ul">
          <a
            class="li"
            href="https://www.patreon.com/chorechampion?fan_landing=true"
            target="_blank"
          >
            <span>
              <center>Link Account</center>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsButton from "../../components/SettingButton";
import {
  handleOAuthRedirectRequest as handleOauth,
  getLoginUrl
} from "../../utilities/patreon/index.js";

export default {
  name: "PatreonLink",
  components: {
    SettingsButton
  }
};
</script>

<style>
</style>